import { Route } from 'react-router-dom'

import { VisitorParkingPage } from '@/pages/visitor-parking'
import { PaymentSuccess as VisitorParkingPaymentSuccess } from '@/pages/visitor-parking/payment-success'

export const visitorParkingRoutesConfig = () => (
  <>
    <Route path="visitor-parking" element={<VisitorParkingPage />} />
    <Route path="visitor-parking/payment-success" element={<VisitorParkingPaymentSuccess />} />
  </>
)
